import { createContext } from "react";
import { ImpersonationState } from "./impersonation";

interface ImpersonationContextType extends ImpersonationState {
  isSavePending: boolean;
  startImpersonation: (userId: string) => Promise<void>;
  endImpersonation: () => Promise<void>;
}

const ImpersonationContext = createContext<ImpersonationContextType | null>(
  null,
);

export default ImpersonationContext;
